<template>
  <div class="container">
    <div class="mb-5">
      <Quarter
        :contentFor="'MonthToMonth'"
        :sisa_point="month.sisa_point"
        :nilai_perolehan="month.total_perolehan"
        :nilai_penukaran="month.total_penukaran_poin"
        :bulan="month.bulan"
        :nama_outlet="month.outlet_name"
        :id_outlet="month.outlet_id"
        :saldo_rebate="month.total_penukaran_poin"
      />
    </div>
    <div class="mt-custom">
      <div v-for="(data, i) in month.data_bulan" :key="i">
        <div :class="+i == month.data_bulan.length - 1 ? 'mb-5 pb-5' : ''">
          <DetailPenjualan
            :contentFor="'monthToMonth'"
            :title="data.nama_produk"
            :target_penjualan="data.target_penjualan"
            :aktual_penjualan="data.aktual_penjualan"
            :nilai_insentif="data.perolehan"
            :ratio_pencapaian="formatNumber(data.ratio_pencapaian)"
            :data_bulan="data"
            class="py-2"
          />
        </div>
      </div>
    </div>

    <!-- <Poin
      :contentFor="'monthToMonth'"
      :poin_carry_over="month.poin_carry_over"
      :perolehan="month.total_perolehan"
      :poin_tersedia="month.total_poin_tersedia"
      :penukaran_poin="month.total_penukaran_poin"
      :sisa_poin="month.sisa_point"
      title="AKUMULASI POIN"
      class="mt-3"
    />
    <Tarif
      :contentFor="'monthToMonth'"
      :rebate_medio="month.total_rebate_medio"
      :rebate_bulanan="month.total_rebate_bulanan"
      :tarif_medio="month.tarif_rebate_medio"
      :tarif_bulanan="month.tarif_rebate"
      :transfer_rebate="month.total_transfer_rebate"
      :total_rebate="month.total_rebate"
      :tarif_quarter="month.tarif_rebate_quarter"
      :rebate_quarter="month.total_rebate_quarter"
      :saldo_rebate="month.saldo_rebate"
      title
      class="mt-3 mb-custom"
    /> -->
    <!--      <BulanTransaksi :contentFor="'monthToMonth'"/>-->
    <div></div>
  </div>
</template>

<script>
import axios from "axios";
import Quarter from "@/components/Quarter/Quarter.vue";
import DetailPenjualan from "@/components/Quarter/DetailPenjualan.vue";
// import Poin from "@/components/Quarter/Poin.vue";
// import BulanTransaksi from "@/components/Quarter/BulanTransaksi.vue";
// import Tarif from "@/components/Quarter/Tarif.vue";

export default {
  components: {
    Quarter,
    DetailPenjualan
    // Poin,
    // BulanTransaksi,
    // Tarif,
  },
  data() {
    return {
      month: []
    };
  },
  methods: {
    normalize(badNumeric) {
      return Number(badNumeric.split(",").join(""));
    },

    monthToMonth() {
      axios
        .get(`${process.env.VUE_APP_URL}dashboard-outlet-mtm`, {
          headers: {
            bulan: this.$route.params.bulan
          },
          params: {
            txtKodeOutlet: this.$route.params.outlet_id,
            token: localStorage.token
          }
        })

        .then(res => (this.month = res.data))
        .catch(err => console.log(err));
    },
    formatNumber(angka) {
      return Intl.NumberFormat("id").format(parseInt(+angka));
    }
  },
  mounted() {
    this.monthToMonth();
  },

  watch: {
    $route: "monthToMonth"
  }
};
</script>

<style scoped>
.mb-custom {
  margin-bottom: 5rem;
}
@media screen and (max-width: 1020px) {
  .mt-custom {
    margin-top: 15rem;
  }
}
</style>
